export const TOKEN_TYPE = 'Bearer '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
export const API_BASE = 'https://emac-plan.directaffinitycx.net/api'
export const AUTH_API_KEY='39abc063-9dc5-4c54-b2de-28efd4d4bd51'